export default "__VITE_ASSET__X_jNkZSL__"